// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/hero-banner-item/hero-banner-item.component.scss
// module id = 353
// module chunks = 0